import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#C8A24D',
      light: '#E0C97F',
      dark: '#9B7D35',
    },
    secondary: {
      main: '#5C3D2E',
      light: '#7A5E4F',
      dark: '#3E2518',
    },
    background: {
      default: '#FAF6EE',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2A231C',
      secondary: '#7A6E60',
    },
    divider: 'rgba(200, 162, 77, 0.15)',
  },
  typography: {
    fontFamily: '"Inter", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Kanit", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.02em',
      color: '#2A231C',
    },
    h2: {
      fontFamily: '"Kanit", sans-serif',
      fontWeight: 600,
      letterSpacing: '-0.01em',
      color: '#2A231C',
    },
    h3: {
      fontFamily: '"Kanit", sans-serif',
      fontWeight: 600,
      letterSpacing: '-0.01em',
      color: '#2A231C',
    },
    h4: {
      fontFamily: '"Kanit", sans-serif',
      fontWeight: 500,
      color: '#2A231C',
    },
    h5: {
      fontFamily: '"Kanit", sans-serif',
      fontWeight: 500,
      color: '#2A231C',
    },
    h6: {
      fontFamily: '"Kanit", sans-serif',
      fontWeight: 500,
      color: '#2A231C',
    },
    body1: {
      lineHeight: 1.7,
      color: '#7A6E60',
    },
    body2: {
      lineHeight: 1.6,
      color: '#7A6E60',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#FAF6EE',
          color: '#2A231C',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontFamily: '"Kanit", sans-serif',
          fontWeight: 500,
          borderRadius: 8,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
  },
});

export default theme;
